// extracted by mini-css-extract-plugin
export default {"SimpleModal":"styles_SimpleModal__M+O8N"};